module.exports = __webpack_public_path__ + "media/images/sirius_bkg-61c5d012fd07ef1761efd30e89a30d0b.svg";